module.exports = __webpack_public_path__ + "static/media/52.0548f064.jpg";